export const keyToColorIndex = (key: string) => {
  return parseInt(key.substr(0, 7) + key.substr(18), 16);
};
